import { gql } from '@apollo/client';
const MARK_NOTIFICATION_AS_READ = gql `
  mutation MarkNotificationAsRead($notificationId: ID!) {
    markNotificationAsRead(notificationId: $notificationId)
  }
`;
export default MARK_NOTIFICATION_AS_READ;
